
import {getTokenBySession} from '../../app/modules/auth/redux/AuthCRUD'

//const DRUPAL_URL_LOGIN = process.env.DRUPAL_URL_LOGIN
const API_URL = process.env.REACT_APP_API_URL

//export const DRUPAL_URL_LOGIN = `${API_URL}/user/login` 
export const DRUPAL_URL_LOGIN = `${API_URL}/login/openid` 

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken, sessionToken, user},
      } = store.getState()
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }else{
	      axios.defaults.withCredentials = true //POUSSE LES COOKIE DANS LES REQUETTES
	      
	      config.headers.credentials = 'include' //POUSSE LES COOKIE DANS LES REQUETTES
      }
      
      if (sessionToken) {
          axios.defaults.withCredentials = true //POUSSE LES COOKIE DANS LES REQUETTES
          
	      config.headers.credentials = 'include' //POUSSE LES COOKIE DANS LES REQUETTES
          config.headers["X-CSRF-Token"] = sessionToken
      }
      
       return config
    },
    (err: any) => Promise.reject(err)
  )
  
   //REPONSE ERROR
   axios.interceptors.response.use((response: any) => {
        return response;
    }, (error: any) => {
			/*
	      if (error.response.status === 403) {
	       	  console.log("REDIRECT LOGIN", DRUPAL_URL_LOGIN, error)
	       	  //REDIRECT DRUPAL CONNEXION
             // window.location.href = DRUPAL_URL_LOGIN + "?redirect=" + window.location.href
	      }
	*/
	      return Promise.reject(error);
	      
    });
  
}
